import React, { useEffect, useState } from 'react'
import { RetreatList,Header,BannerSection,TransformSection,IncludedSection,Timeline,RetreatCard} from '../../../components/template';
const Innergise = () => {

    const heading = <span className="inline-block pl-6 md:pl-20">Why Attend?</span>;  
const features = [
  { icon: "🌿", text: "Physical Vitality – Reignite energy, strengthen the immune system & boost endurance" },
  { icon: "🧠", text: "Mental Resilience – Overcome self-doubt, sharpen focus & cultivate unshakable confidence" },
  { icon: "💛", text: "Emotional Mastery – Release stress, break negative cycles & develop inner peace" },
  { icon: "🔍", text: "Purpose Discovery – Gain clarity, align with your highest potential & take inspired action" }
];
const icons = ["✨", "🧘‍♂️", "🏆"]; 
const retreats = [
  {
    // image: "assets/synnergise/.jpg",
    date: "To be announced soon",
    place: "To be announced soon",
    // price: "Starting from Rs 19,000 + Taxes",
  },
];

// useEffect(() => {
//   fetch(`http://localhost:5000/app/retreats/upcoming`)
//     .then((res) => res.json())
//     .then((data) => {
//       if (data.success) {
//         // Normalize to array because API may return object
//         const retreatArray = Array.isArray(data.data) ? data.data : [data.data];
//         setRetreats(retreatArray);
//       } else {
//         console.error("Failed to fetch retreats:", data.message);
//       }
//     })
//     .catch((err) => console.error("Error fetching retreats:", err));
// }, []);

const transformHeading = "How Will It Transform You?";
const transformImage = "/assets/retreats/innergise11.JPG";
const ticons=["🔥","🌊","💡","🚀","🧘","🌟","💪"];
const transformPoints = [
  <>
    <b> Break Free from Stress & Anxiety –</b> Rewire your mind with proven resilience techniques
  </>,
  <>
    <b> Master Your Emotions –</b> Learn how to process and transform emotions into inner strength
  </>,
  <>
    <b> Eliminate Mental Clutter –</b> Shift from overthinking to clarity, focus, and intentional action
  </>,
  <>
    <b> Develop a Growth Mindset –</b> Cultivate discipline, self-motivation & success-oriented thinking
  </>,
  <>
    <b> Find Inner Balance –</b> Experience deep relaxation & emotional healing through breathwork
  </>,
  <>
    <b> Unlock Your Life’s Purpose –</b> Self-inquiry and reflection techniques to align with your calling
  </>,
  <>
    <b>Enhance Physical Health –</b> Improve flexibility, strengthen muscles, and boost overall vitality with guided yogic practices
  </>
];
const whatsIncludedHeading = "What’s Included?";
const whatsIncludedItems = [
  { icon: "🏡", title: "Comfortable & Inspiring Stay" },
  { icon: "🥗", title: "Nutrient-Rich Vegetarian Meals" },
  { icon: "🧘‍♂️", title: "Daily Yoga, Breathwork & Meditation" },
  { icon: "🧠", title: "Mindset & Emotional Resilience Training" },
  { icon: "🔍", title: "Guided Self-Inquiry & Vedantic Techniques" },
  { icon: "📖", title: "Personal Growth Journaling & Reflection" }
];
const whatsIncludedMainImage="/assets/retreats/innergise 10.jpg"
const whatsIncludedOverlayImage=""
const timeheading="Your 4 day Retreat Journey";
const journey = [
    {
      day: "Day 1",
      title: "Ignite Your Energy",
      activities: [
        "🧘‍♂️ Dynamic Hatha Yoga & Breathwork to awaken vitality.",
        "🧠 Mindset Rewiring & Fire Meditation to release limiting beliefs."
      ]
    },
    {
      day: "Day 2",
      title: "Strengthen Resilience",
      activities: [
        "🌅 Power Yoga & Pranayama to build endurance.",
        "💨 Emotional Resilience & Self-Inquiry to overcome stress & fears."
      ]
    },
    {
      day: "Day 3",
      title: "Discover Your Purpose",
      activities: [
        "💡 Happiness Psychology & Self-Discovery Journaling for clarity.",
        "🎭 Breakthrough Transformation Activity to unlock hidden potential."
      ]
    },
    {
      day: "Day 4",
      title: "Integrate & Elevate",
      activities: [
        "🌞 Energy Flow Yoga & Breathwork for alignment.",
        "📝 Purpose Mapping & Gratitude Circle to seal transformation."
      ]
    }
  ];
  const mediaItems = [
    { type: "image", src: "/assets/innergise/innergise 5.jpg" },
    { type: "image", src: "/assets/innergise/innergise 3.jpg" },
    { type: "image", src: "/assets/innergise/innergise 7.jpg" },
    { type: "image", src: "/assets/innergise/innergise 11.JPG" },
    { type: "image", src: "/assets/retreats/innergise11.jpg" },
    { type: "image", src: "/assets/innergise/INNERGISE 1.jpg" },
    { type: "image", src: "/assets/innergise/innergise 10.jpg" },
      ]
    // const [retreats, setRetreats] = useState([]);


  return (
    <>
    <div className="w-full text-center p-8 md:p-10 bg-light">
          <h1 className="text-2xl md:text-4xl  font-bold text-[#8B2218] leading-tight">
          SYNERGISE RETREAT          </h1>
          <h2 className="text-lg md:text-2xl  text-[#578d48] font-bold mt-4 md:mt-14">
          Energize Your Mind & Body | Build Emotional Resilience | Discover Your Purpose          </h2></div>
         <section className="py-10 px-6 md:px-20 flex flex-col gap-6 bg-light items-center">
      {/* <h2 className="text-2xl md:text-3xl font-bold text-secondary">Upcoming Retreats</h2>
  <RetreatList retreats={retreats} type="innergise" /> */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary">Upcoming Retreats</h2>
        {retreats.map((retreat, index) => (
          <RetreatCard key={index} {...retreat} />
        ))}
  
    </section>
     <Header
           description={[  "4-day Immersive retreat to strengthen Body and Mind",
            "Integration of Techniques from Yogic & Behavioural Science",
            "Led by an IITian-turned-Wellness & Mindset Coach"
          ]}
        
          mainImage="/assets/_DSC1537.jpg"
          sideImages={["/assets/yog.jpg", "/assets/yog2.jpg"]} 
          mediaItems={mediaItems} 
          showVideo={true} 
          icons={icons}
       
        />
       
 <BannerSection heading={heading}  features={features}/>
      <TransformSection  imageSrc={transformImage} altText="Transformation experience" heading={transformHeading}  points={transformPoints} ticons={ticons} />
      <IncludedSection heading={whatsIncludedHeading}
      mainImage={whatsIncludedMainImage}
      overlayImage={whatsIncludedOverlayImage}
      items={whatsIncludedItems}/>
      <Timeline timeheading={timeheading} journey={journey}/>
    </>
  )
}

export default Innergise;